import { createFileRoute, redirect } from "@tanstack/react-router";
import { CreateDomain, EditContent } from "@/features/consent-solutions";
import { AuthorizedRouteContext } from "@/routes/_authorized/route";
import { checkUserPermissions } from "@/features/auth";

const Route = createFileRoute("/_authorized/consent-solutions/$csId/domains/create/")({
  beforeLoad: async ({ context, params }) => {
    const { userDetails } = context as AuthorizedRouteContext;
    const { csId } = params;

    const isUserPermitted = checkUserPermissions(userDetails, ["DOMAIN_CREATE_INTERNAL"], csId);

    if (!isUserPermitted) {
      redirect({
        to: "/consent-solutions",
        replace: true,
        throw: true,
      });
    }
  },
  component: () => (
    <EditContent>
      <CreateDomain />
    </EditContent>
  ),
});

export { Route };
